import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '../main.styl';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light:{
                primary: '#8BC34A',
                secondary: '#f5f5f5',
                accent: '#8BC34A',
                error: '#F44336',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            },
            dark:{
                primary: '#8BC34A',
                secondary: '#f5f5f5',
                accent: '#8BC34A',
                error: '#F44336',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            }
        }
     },
});
